import { PropsWithChildren } from 'react';

import { useAppData } from 'src/app/data';

import { DevToolsProvider as InternalProvider } from './context';

export const DevToolsProvider = ({ children }: PropsWithChildren<{}>) => {
  const { user } = useAppData();
  const isEnabled = !!user?.isAtlassian;

  // Always return the provider, conditionally render the (code split) dialog
  return <InternalProvider isEnabled={isEnabled}>{children}</InternalProvider>;
};

export { LazyDevToolsDialog } from './lazy-dialog';
